import { useCallback, useEffect, useState } from "react";
import { StockService } from "../../../../services/StockService";

// Trees are being retired in favour of species. Until the backend stores `speciesId` on
// tree-fell items, the legacy tree list maps old items to a species and supplies a `treeId`
// for new ones. Once the /Tree endpoints are gone, GetTrees returns null and this falls away.
export const useSpeciesOptions = () => {
  const [options, setOptions] = useState([]);
  const [speciesIdByTreeId, setSpeciesIdByTreeId] = useState({});

  useEffect(() => {
    Promise.all([StockService.GetAllSpecies(), StockService.GetTrees()]).then(([species, trees]) => {
      const treeToSpecies = {};
      const firstTreeForSpecies = {};
      (trees || []).forEach((t) => {
        treeToSpecies[t.treeId] = t.speciesId;
        if (!(t.speciesId in firstTreeForSpecies)) firstTreeForSpecies[t.speciesId] = t.treeId;
      });
      setSpeciesIdByTreeId(treeToSpecies);
      setOptions(
        (species || []).map((s) => ({
          ...s,
          value: s.speciesId,
          label: s.speciesCode ? `${s.speciesCode} — ${s.speciesName}` : s.speciesName,
          legacyTreeId: firstTreeForSpecies[s.speciesId] || 0,
        }))
      );
    });
  }, []);

  const speciesIdFor = useCallback(
    (item) => item.speciesId || speciesIdByTreeId[item.treeId] || 0,
    [speciesIdByTreeId]
  );

  const optionFor = useCallback(
    (item) => options.find((o) => o.value === speciesIdFor(item)) || null,
    [options, speciesIdFor]
  );

  return { options, speciesIdFor, optionFor };
};
